import { RelayPatchCachingServersGzDataProvider } from '../dataProvider/RelayPatchCachingServersGzDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class RelayPatchCachingServersDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, RelayPatchCachingServersGzDataProvider);
  }
}
